import {
  Colors,
  NewAsset,
  SlideAction,
  SlideLayout,
  Spacing,
  TopModalBar,
  ViewMode,
} from '@gripp/shared-ui';
import { useRef, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { HeaderResetButton } from '../../shared/components/headerResetButton';
import { MediaPicker } from '../../shared/components/media/mediaPicker';
import { AssetComponent } from './assetComponent';
import { AssetsFilters } from './assetsFilters';
import EditGroup from './editGroup';

export const AssetNew = () => {
  const navigate = useNavigate();
  const [selectedGroups, setSelectedGroups] = useState<
    Array<{ id: string; name: string }>
  >([]);
  const [isGroupsPanelOpen, setIsGroupsPanelOpen] = useState(false);
  const resetGroupsRef = useRef<(() => void) | undefined>(undefined);

  const leftColumn = {
    title: 'assets.menu.title',
    mainComponent: <AssetComponent />,
    headerComponent: <AssetsFilters />,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'asset.newAsset',
    showBackButton: true,
    backButtonTransition: SlideAction.SINGLE,
    onBackButtonPress: () => navigate('/assets'),
    mainComponent: (
      <NewAsset
        onCancel={() => navigate('/assets')}
        mediaPicker={MediaPicker}
        topComponentBar={TopModalBar}
        styles={styles}
        onSaved={(assetId: string) => {
          navigate(`/assets/${assetId}`);
        }}
        selectedGroups={selectedGroups}
        onGroupsChange={setSelectedGroups}
        onSelectorEdit={() => setIsGroupsPanelOpen(true)}
      />
    ),
    disableScroll: true,
  };

  const thirdColumn = isGroupsPanelOpen
    ? {
        title: 'asset.groups',
        mainComponent: (
          <EditGroup
            selectedGroups={selectedGroups}
            onGroupsChange={setSelectedGroups}
            resetRef={resetGroupsRef}
          />
        ),
        headerComponent: (
          <View style={styles.headerResetButton}>
            <HeaderResetButton onReset={() => resetGroupsRef.current?.()} />
          </View>
        ),
        showBackButton: true,
        disableScroll: true,
        onBackButtonPress: () => setIsGroupsPanelOpen(false),
      }
    : undefined;

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      thirdColumn={thirdColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.white,
    flex: 1,
  },
  contentContainer: {
    flex: 1,
    paddingHorizontal: Spacing.basePadding.paddingHorizontal,
    paddingVertical: Spacing.basePadding.paddingVertical,
  },
  headerResetButton: {
    marginRight: 8,
  },
});
